module.exports = __webpack_public_path__ + "logo2.bcc5d671.png";